import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, blue } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const secondaryColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--secondary-color-main'],
          highContrast: unityLightTokens['--secondary-color-high-contrast'],
          lowContrast: unityLightTokens['--secondary-color-low-contrast'],
        }
      : {
          main: unityDarkTokens['--secondary-color-main'],
          highContrast: unityDarkTokens['--secondary-color-high-contrast'],
          lowContrast: unityDarkTokens['--secondary-color-low-contrast'],
        };
  }
  return mode === 'light'
    ? {
        main: blue[600],
        highContrast: blue[800],
        lowContrast: blue[150],
      }
    : {
        main: blue[500],
        highContrast: blue[300],
        lowContrast: blue[700],
      };
};
